import StudentClassroomAPI from '@/apis/business/account/student-classroom-api.js'
import ClassroomAPI from '@/apis/business/account/classroom-api.js'
import Enumeration from '@/common/enumeration.js'
import UserOptionCache from '@/utils/cache-data/src/user-option.ts'

export default {
  namespaced: true,
  state: {
    students: [],
    classroom: {},

    isSelectedStudent: false,

    studentClassroom: {}
  },

  getters: {},

  mutations: {
    /**
     * @description set data cho state students
     * @param {*} state
     * @param {*} students
     */
    setStudents (state, data) {
      state.students = data.StudentClassroomLMs.map(item => {
        item.HasAccount = false
        data.StudentClassroomHasAccount.map(hasAccount => {
          if (item?.SISAPCode === hasAccount?.SISAPCode) {
            item.HasAccount = true
            item.UserName = hasAccount.UserName
          }
        })
        return item
      })
    },

    /**
     * @description set data cho state classroom
     * @param {*} state
     * @param {*} students
     */
    setClassroom (state, classroom) {
      if (classroom) {
        state.classroom = classroom
      }
    },

    /**
     * @description set trạng thái chọn học sinh tham gia lớp
     * @author NTQuy
     * @param {*} state
     */
    setSelectedStudent (state) {
      state.isSelectedStudent = true
    },

    addStudentClassroom (state, studentClassroom) {
      state.studentClassroom = studentClassroom
    }
  },

  actions: {
    /**
     * @description Lấy danh sách học sinh từ bên LMS
     * @author NTQuy
     * @param {*} context
     * @returns
     */
    async getStudents (context, params) {
      const res = await StudentClassroomAPI.getAsync(`/available?classID=${params?.classEMISID}&orgID=${params.organizationID}`)

      context.commit('setStudents', res.Data)
      return res.Data
    },

    /**
     * @description Lấy thông tin lớp theo ClassEMISID
     * @author NTQuy
     * @param {*} context
     * @param {*} params
     */
    async getClassroom (context, params) {
      const res = await ClassroomAPI.getAsync(`/classroom?classEMISID=${params.classEMISID}&organizationID=${params.organizationID}`)

      context.commit('setClassroom', res.Data)
      return res.Data
    },

    /**
     * @description Lấy thông tin lớp học đồng thời join vào lớp học luôn
     * @author NTQuy
     * @param {*} context
     * @param {*} params
     */
    async addStudentClassroom (context, params) {
      const classroomRes = await ClassroomAPI.getAsync(`classroom?classEMISID=${params.dataSession.classEMISID}&organizationID=${params.dataSession.organizationID}`)
      const classroom = classroomRes.Data
      const student = params.student

      if (!classroom) {
        return
      }
      delete classroom.Id
      if (!classroom.EnableApprove) {
        student.ApproveStatus = Enumeration.StudentApproveStatus.Approve
      }

      const studentClassroom = { ...classroom, ...student }

      await StudentClassroomAPI.postAsync('', studentClassroom)
      const optionParam = {
        OptionID: params.OptionID,
        OptionValue: classroom.GradeID,
        OptionType: Enumeration.OptionType.Number,
        Description: params.Description
      }
      await UserOptionCache.SaveUserOption(optionParam)

      // return new Promise((resolve, reject) => {
      //   ClassroomAPI.getAsync(`/class-emisid/${params.classEMISID}`).then(res => {
      //     return res.Data
      //   }).then((classroom) => {
      //     const studentClassroom = { ...classroom, ...params.student }
      //     StudentClassroomAPI.postAsync('', studentClassroom).then(res => {
      //       studentClassroom.Id = res.Data
      //       context.commit('addStudentClassroom', studentClassroom)
      //       resolve(true)
      //     })
      //   }).catch(err => {
      //     reject(err)
      //   })
      // })
    },

    /**
     * @description Kiểm tra học sinh đã có trong lớp hay chưa
     * @author NTQuy
     * @param {*} context
     * @param {*} params
     * @returns
     */
    checkDublicateStudentClassroom (context, params) {
      return new Promise((resolve, reject) => {
        StudentClassroomAPI.getAsync(`/check-dublicate?classCode=${params.classCode}&studentID=${params.studentID}`).then(res => {
          resolve(res.Data)
        })
      })
    },

    joinFormalClass (context, isUpdateOrg = false) {
      return new Promise((resolve, reject) => {
        StudentClassroomAPI.postAsync('classemisid', isUpdateOrg)
          .then((res) => {
            if (res.IsSuccess) {
              context.commit('addStudentClassroom', res.Data)
            }
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
